import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Rail } from "../components/Rail";
import { ChatList } from "../components/chat/ChatList";
import { ChatArea } from "../components/chat/ChatArea";
import { ProfilePanel } from "../components/chat/ProfilePanel";
import api from "../lib/api";
import { useWS } from "../hooks/useWS";
import { useAuth } from "../context/AuthContext";

export default function ChatsPage() {
  const { chatId } = useParams();
  const nav = useNavigate();
  const { refreshAccount } = useAuth();
  const [chats, setChats] = useState([]);
  const [messages, setMessages] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");

  const active = chats.find((c) => c.id === chatId);

  const loadChats = useCallback(async () => {
    const params = new URLSearchParams();
    if (filter !== "all") params.set("interest", filter);
    if (q) params.set("q", q);
    const { data } = await api.get(`/chats?${params}`);
    setChats(data);
  }, [filter, q]);

  useEffect(() => { loadChats(); }, [loadChats]);

  useEffect(() => {
    if (!chatId) { setMessages([]); return; }
    api.get(`/chats/${chatId}/messages`).then((r) => setMessages(r.data)).catch(() => nav("/chats"));
  }, [chatId, nav]);

  const refreshMessages = useCallback(() => {
    if (!chatId) return;
    api.get(`/chats/${chatId}/messages`).then((r) => setMessages(r.data)).catch(() => {});
  }, [chatId]);

  useWS((event, data) => {
    if (event === "chat.upsert") {
      setChats((prev) => {
        const rest = prev.filter((c) => c.id !== data.id);
        return [data, ...rest].sort((a, b) => (b.last_message_at || "").localeCompare(a.last_message_at || ""));
      });
    }
    if (event === "message.created" && data.chat_id === chatId) {
      setMessages((prev) => (prev.some((m) => m.id === data.id) ? prev : [...prev, data]));
    }
    if (event === "chat.processing" && data.chat_id === chatId) setProcessing(true);
    if (event === "chat.completed") {
      if (data.chat_id === chatId) {
        setProcessing(false);
        refreshMessages();
      }
      refreshAccount();
    }
  });

  const updateChat = (chat) => setChats((prev) => prev.map((c) => (c.id === chat.id ? chat : c)));

  return (
    <div className="flex h-screen overflow-hidden bg-ink text-paper">
      <Rail />
      <ChatList chats={chats} activeId={chatId} filter={filter} setFilter={setFilter} q={q} setQ={setQ}
        onSelect={(id) => nav(`/c/${id}`)} />
      {active ? (
        <>
          <ChatArea chat={active} messages={messages} setMessages={setMessages} processing={processing} onChatUpdate={updateChat} />
          <ProfilePanel chat={active} />
        </>
      ) : (
        <div className="flex flex-1 flex-col items-center justify-center gap-3 text-center">
          <div className="flex gap-1.5">
            {[0, 1, 2].map((i) => (
              <span key={i} className="h-2 w-2 animate-bounce-dot rounded-full bg-mint" style={{ animationDelay: `${i * 0.15}s` }} />
            ))}
          </div>
          <p className="text-sm text-muted">Pilih percakapan untuk mulai</p>
          <p className="max-w-xs text-xs text-faint">Belum ada chat? Gunakan Simulator untuk mengirim pesan sebagai pelanggan dan lihat AI membalas.</p>
        </div>
      )}
    </div>
  );
}
